import utils from "./util/utils";

const navigation = function () {
  const menuToggler = $('.js-menu-toggler');

  menuToggler.click(function () {
    $('.js-navigation').addClass('is--active');
  })


  $('.js-navigation-close').click(function () {
    $('.js-navigation').removeClass('is--active');

  });

  $(document).mouseup(function(e)
  {
    var container = $('.js-navigation');

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0)
    {
      $('.js-navigation').removeClass('is--active');
    }
  });

}

export default navigation;
